/**
 * Mega Menu AJAX Loader (Desktop)
 * Loads the mega menu via AJAX on the first click on the catalog button and injects it into the DOM.
 * Opening/closing is handled by UIkit (uk-drop toggle: .btn-catalog), so the menu is fetched only once.
 */

(function($) {
    'use strict';

    const MegaMenuLoader = {
        isLoaded: false,
        isLoading: false,
        currentLang: '',
        dropMenuSelector: '.uk-drop.drop-menu',
        buttonSelector: '.btn-catalog',
        loaderSelector: '.menu-loader',
        contentSelector: '.mega-menu-content',

        /**
         * Initialize
         */
        init: function() {
            const self = this;

            this.currentLang = document.documentElement.lang ||
                              (window.location.pathname.includes('/ro') ? 'ro' : 'ru');

            $(document).on('click', this.buttonSelector, function() {
                self.handleClick();
            });
        },

        /**
         * Handle catalog button click
         */
        handleClick: function() {
            if (this.isLoaded || this.isLoading) {
                return;
            }

            this.loadMegaMenu();
        },

        /**
         * Load mega menu via AJAX
         */
        loadMegaMenu: function() {
            const self = this;

            this.isLoading = true;
            $(this.loaderSelector).show();
            $(this.contentSelector).hide();

            $.ajax({
                url: '/' + this.currentLang + '/ajax/mega_menu/',
                type: 'POST',
                data: { lang: this.currentLang },
                dataType: 'json',
                timeout: 15000,
                success: function(response) {
                    self.handleSuccess(response);
                },
                error: function(xhr, status, error) {
                    self.handleError(status, error);
                },
                complete: function() {
                    self.isLoading = false;
                }
            });
        },

        /**
         * Handle a successful response
         */
        handleSuccess: function(response) {
            if (!response.success) {
                this.handleError('error', response.message);
                return;
            }

            const $content = $(this.contentSelector);
            const $loader = $(this.loaderSelector);

            $content.html(response.html);
            $loader.hide();
            $content.show();

            this.isLoaded = true;

            if (window.UIkit) {
                UIkit.update($(this.dropMenuSelector)[0]);
            }
        },

        /**
         * Handle error
         */
        handleError: function(status, error) {
            console.error('Mega menu load error:', status, error);
            $(this.loaderSelector).hide();
            $(this.contentSelector).html(
                '<div class="uk-text-center uk-padding">' +
                '<p style="color:#ed0000;">Не удалось загрузить каталог</p>' +
                '</div>'
            );
            $(this.contentSelector).show();
        }
    };

    $(document).ready(function() {
        MegaMenuLoader.init();
    });

})(jQuery);
